import { useEffect, useState } from "react";

const Getinvolved = () => {
  const [stories, setStories] = useState([]);

  useEffect(() => {
    fetch("storylinks.json")
      .then((res) => res.json())
      .then((data) => setStories(data))
      .catch((err) => console.error("Failed to load stories:", err));
  }, []);

  return (
    <section id="stories" className="bg-purple-50 py-20 px-4 sm:px-6 lg:px-8">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-extrabold text-purple-700 mb-4">
            Real Stories from Real Heroes
          </h2>
          <h3 className="text-4xl font-extrabold text-purple-700 mb-4">
             Mental Health pills
          </h3>
          <p className="text-lg text-gray-700 leading-relaxed max-w-3xl mx-auto">
            <span className="block mb-3">
              If you have a story to tell — a journey of strength, struggle, hope, or change —
              we would love to hear it. Just send your story through our <a href="/contact" className="text-purple-600 underline hover:text-purple-800">Contact Us</a> page, and it could be featured here.
            </span>
            <span className="block mb-3">
              Your words, no matter how small they may seem, can inspire someone to take that first bold step toward a better life.
              A single story has the power to spark change, heal wounds, and empower another woman who needs to hear: <strong>"You're not alone."</strong>
            </span>
            <span className="block">
              Whether you seek support or offer it, either way, you’re part of something bigger.
              <strong className="text-purple-700"> Every voice matters. Every step counts. Be the light for someone else’s journey.</strong>
            </span>
          </p>
        </div>

        <div className="grid gap-8 md:grid-cols-2">
          {stories.map((story, idx) => (
            <div
              key={idx}
              className="bg-white p-6 rounded-lg shadow hover:shadow-md transition duration-300 border-l-4 border-purple-500"
            >
              <a
                href={story.mediumUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-xl font-semibold text-purple-700 hover:underline"
              >
                {story.name}
              </a>
              <p className="text-sm text-gray-600 italic">{story.title}</p>
              <p className="text-gray-700 mt-3 text-sm">{story.description}</p>
              <a
                href={story.mediumUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm text-purple-600 mt-3 inline-block hover:text-purple-800 font-medium"
              >
                Read on Medium →
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Getinvolved;
